import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllSupplierCategoryQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllSupplierCategory (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                name
                createdAt
                updatedAt
            }
      }
    }
  `

  export default query;